import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import { API_BASE_URL } from '../config/api-base-url.token';
import type {
  ApproveSenderIdentityResponse,
  CreateSenderIdentityPayload,
  DenySenderIdentityResponse,
  SenderIdentityNotificationSettings,
  SenderIdentityListResponse,
  SenderIdentitySummary,
  UpdateSenderIdentityPayload,
} from '../models/sender-identity.models';

@Injectable({ providedIn: 'root' })
export class SenderIdentityApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  listSenderIdentities(): Observable<SenderIdentityListResponse> {
    return this.http.get<SenderIdentityListResponse>(`${this.baseUrl}/sender-identities`);
  }

  createSenderIdentity(payload: CreateSenderIdentityPayload): Observable<SenderIdentitySummary> {
    return this.http.post<SenderIdentitySummary>(`${this.baseUrl}/sender-identities`, payload);
  }

  updateSenderIdentity(id: string, payload: UpdateSenderIdentityPayload): Observable<SenderIdentitySummary> {
    return this.http.patch<SenderIdentitySummary>(`${this.baseUrl}/sender-identities/${id}`, payload);
  }

  deleteSenderIdentity(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/sender-identities/${id}`);
  }

  resendVerification(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/sender-identities/${id}/resend-verification`, {});
  }

  getNotificationSettings(id: string): Observable<SenderIdentityNotificationSettings> {
    return this.http.get<SenderIdentityNotificationSettings>(`${this.baseUrl}/sender-identities/${id}/notification-settings`);
  }

  updateNotificationSettings(
    id: string,
    payload: SenderIdentityNotificationSettings,
  ): Observable<SenderIdentityNotificationSettings> {
    return this.http.put<SenderIdentityNotificationSettings>(
      `${this.baseUrl}/sender-identities/${id}/notification-settings`,
      payload,
    );
  }

  approveSenderIdentity(token: string): Observable<ApproveSenderIdentityResponse> {
    return this.http.post<ApproveSenderIdentityResponse>(`${this.baseUrl}/sender-identities/approve`, {
      token,
    });
  }

  denySenderIdentity(token: string): Observable<DenySenderIdentityResponse> {
    return this.http.post<DenySenderIdentityResponse>(`${this.baseUrl}/sender-identities/deny`, {
      token,
    });
  }
}
